import { RoundedBadge } from '@/components/rounded-badge';
import { getIconPathFromTokenSymbol } from '@/utils';
import { Heading, HStack, Image, Text, VStack } from '@chakra-ui/react';

export const Hero = () => {
  return (
    <HStack
      justifyContent={['center', 'center', 'center', 'space-between']}
      w="full"
      bgColor="#0F2F24"
      borderRadius="3xl"
      overflow="hidden"
      color="fg.inverted"
      h={396}
    >
      <Image src="/assets/optimizer/hero-left.avif" h={468} display={['none', 'none', 'none', 'initial']} />
      <VStack maxW={600} gap={4} textAlign="center" py={10} px={4}>
        <Image src="/assets/optimizer/optimizer-icon.svg" h={16} />
        <Heading fontWeight="700" size="4xl">
          Optimizer
        </Heading>
        <Text fontFamily="heading" fontSize="lg" fontWeight="500" opacity={0.8}>
          Maximize yield in just a few clicks
        </Text>
        <RoundedBadge
          color="fg.inverted"
          bgColor="rgba(255, 255, 255, 0.1)"
          fontSize="sm"
          gap={2}
          px={3}
          py={[4, 4, 4, 4, 2]}
          flexWrap={['wrap']}
          justifyContent={'center'}
          w={['full', 'full', 'full', 'full', 550]}
        >
          <Image src="/assets/vaults/up-arrow-circle.svg" boxSize={6} />
          Base Yield + <Image src={getIconPathFromTokenSymbol('PLUME')} boxSize={6} />
          PLUME Incentives + <Image src="/assets/pp-circle.svg" boxSize={6} /> Plume Points ={' '}
          <Image src="/assets/vaults/yield-optimizer.svg" boxSize={6} />
          Optimizer
        </RoundedBadge>
        {/* commenting this out as it may come back post launch  */}
        {/* <RoundedBadge
          color="fg.inverted"
          h={10}
          bgColor="rgba(255, 255, 255, 0.1)"
          fontSize="md"
          overflow="hidden"
          position="relative"
          w={['full', 'full', 'full', 'full', 600]}
          px={6}
        >
          <Box
            position="absolute"
            top={0}
            left={0}
            h="100%"
            w={`60%`}
            bg="#236B53"
            zIndex={0}
            transition="width 0.3s ease"
          />

          <Text fontWeight="500" position="relative" zIndex={1} color="fg.inverted">
            $M TVL
          </Text>
        </RoundedBadge>
        <Text opacity={0.8}>Earn a 3x PP multiplier on any deposits before total Optimizer TVL reaches $100M</Text> */}
        <HStack>
          <Text fontSize="sm" fontWeight="500" opacity={0.8}>
            Powered by
          </Text>
          <HStack>
            <Image src="/assets/vaults/nucleus.svg" />
            <Text opacity={0.8}>Nucleus</Text>
          </HStack>
          <HStack>
            <Image src="/assets/vaults/royco.svg" />
            <Text opacity={0.8}>Royco</Text>
          </HStack>
        </HStack>
      </VStack>
      <Image src="/assets/optimizer/hero-right.avif" h={468} display={['none', 'none', 'none', 'initial']} />
    </HStack>
  );
};
